const text =  {
  en: {
    greeting: "Hello",
    DOCUMENT_IS_NOT_UNIQUE: "You already in this course!",
    APPLY_SUCCESS: "Course apply successfully",
  },
};

exports.default = text;